export const OTP_LENGTH = 6;

export const RESET_CODE_COUNTDOWN_LIMIT = 60;

export const OTP_FORM_INITIAL_VALUES = {
  otp: "",
};

export const INVALID_OTP_ERROR = "Invalid OTP.";
